import { CONSTANT_DATA_FIELD } from '../../../../utils/constants';

export const DESK_PENDENCY_SEARCH = [
    {
        formData: [
            {
                titleCode: 'Application Type',
                title: 'Application Type',
                field: 'type',
                class: 'col-6',
                isRequired: true,
                type: CONSTANT_DATA_FIELD.SELECT_FIELD
            },
            {
                titleCode: 'INDUSTRIAL_ESTATE',
                title: 'Industrial Estate',
                field: 'industrialEstate',
                class: 'col-6',
                type: CONSTANT_DATA_FIELD.SELECT_FIELD
            }
        ]
    }
];
export const DESK_PENDENCY_SEARCH_TABLE = [
    {
        titleCode: 'APPLICATION_TYPE',
        colName: 'Application Type',
        fieldName: 'applicationType',
        clsName: 'col-sm-2 font-14 column-text-start',
        id: 0
    },
    {
        titleCode: 'ENTITY_NAME',
        colName: 'Entity Name',
        fieldName: 'entityName',
        clsName: 'application-number column-text-start',
        id: 1
    },
    {
        titleCode: 'ESTATE_NAME',
        colName: 'Estate Name',
        fieldName: 'estateName',
        clsName: 'col-sm-1 column-text-start',
        id: 2
    },
    {
        titleCode: 'PLOT_NUMBER',
        colName: 'Plot Number',
        fieldName: 'plotNumber',
        clsName: 'col-sm-1 column-text-start',
        id: 3
    },
    {
        titleCode: 'APPLICATION_NO',
        colName: 'Application No.',
        fieldName: 'applicationNo',
        clsName: 'application-number column-text-start',
        id: 4,
        isClickable: true
    },
    {
        titleCode: 'DATE_OF_SUBMISSION',
        colName: 'Date of Submission',
        fieldName: 'applicationSubmissionDate',
        clsName: 'col-sm-2 column-text-start',
        id: 5,
        isDate: true
    },
    {
        titleCode: 'STATUS',
        colName: 'Status',
        fieldName: 'status',
        clsName: 'col-sm-2 column-text-start',
        id: 6
    },
    // {
    // 	titleCode: 'PENDING_WITH',
    // 	colName: 'Pending With',
    // 	fieldName: 'currentOwner',
    // 	fieldName2: 'currentOwnerDesig',
    // 	clsName: 'col-sm-2 column-text-start',
    // 	id: 8
    // },
    {
        titleCode: 'PENDENCY',
        colName: 'Pendency',
        fieldName: 'deskPendencyDays',
        clsName: 'col-sm-1 column-text-start',
        id: 7,
        toolTipDetails: {
            position: 'bottom',
            content: '<div>Pendency (No. of Days) </div>',
            variant: { color: 'white' },
            className: 'position-relative'
        }
    }
];
